import Link from '../../Link';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function List(props): JSX.Element {
    const { details, type } = props;
    //console.log(props);
    return (
        <table className="w-full leading-normal  border-gray-200 shadow-profile rounded-lg">
            <thead className="hidden md:contents text-gray-600 text-xs   rounded-lg font-semibold border-gray tracking-wider text-center px-5 py-3 bg-gray-100 uppercase border-b-2 border-gray-200">
                <tr className="border-b border-gray  rounded-lg ">
                    <th
                        scope="col"
                        className="text-gray-dark border-gray border-b-2 border-t-2 border-gray-200 py-3 px-3 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                    >
                        Deporte
                    </th>
                    <th
                        scope="col"
                        className="text-gray-dark border-gray border-b-2 border-t-2 border-gray-200 py-3 px-3 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                    >
                        Club
                    </th>
                    <th
                        scope="col"
                        className="text-gray-dark border-gray border-b-2 border-t-2 border-gray-200 py-3 px-3 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                    >
                        Cancha
                    </th>
                    <th
                        scope="col"
                        className="text-gray-dark border-gray border-b-2 border-t-2 border-gray-200 py-3 px-3 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                    >
                        {type !== 'challenge' ? 'Pago' : 'Precio por Equipo'}
                    </th>
                    <th
                        scope="col"
                        className="text-gray-dark border-gray border-b-2 border-t-2 border-gray-200 py-3 px-3 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                    >
                        Fecha Inicio
                    </th>
                    <th
                        scope="col"
                        className="text-gray-dark border-gray border-b-2 border-t-2 border-gray-200 py-3 px-3 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                    >
                        Fecha Final
                    </th>
                    {type !== 'challenge' ? (
                        <th
                            scope="col"
                            className="text-gray-dark border-gray border-b-2 border-t-2 border-gray-200 py-3 px-3 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            Estatus
                        </th>
                    ) : (
                        <>
                            <th
                                scope="col"
                                className="text-gray-dark border-gray border-b-2 border-t-2 border-gray-200 py-3 px-3 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                            >
                                Tipo
                            </th>
                            <th
                                scope="col"
                                className="text-gray-dark border-gray border-b-2 border-t-2 border-gray-200 py-3 px-3 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                            >
                                Desafiador
                            </th>
                            <th
                                scope="col"
                                className="text-gray-dark border-gray border-b-2 border-t-2 border-gray-200 py-3 px-3 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                            >
                                Desafiado
                            </th>
                            <th
                                scope="col"
                                className="text-gray-dark border-gray border-b-2 border-t-2 border-gray-200 py-3 px-3 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                            >
                                Ver
                            </th>
                        </>
                    )}
                </tr>
            </thead>
            <tbody>
                {details &&
                    details.length > 0 &&
                    details.map((d, i) => (
                        <tr
                            className="hover:bg-gray-100  flex-col md:flex-row flex md:table-row"
                            key={`details-${i}-${d.sport}`}
                        >
                            <td className="py-4 px-6 border-b border-gray-200 text-gray-900 text-sm ">
                                <div className="flex-none  md:flex items-center">
                                    <div className="ml-3">
                                        <p className="text-gray-900 whitespace-nowrap">
                                            <span className="text-sm-rent font-bold pr-4 md:hidden">Deporte:</span>
                                            {d.sport}
                                        </p>
                                    </div>
                                </div>
                            </td>
                            <td className="py-4 px-6 border-b border-gray-200 text-gray-900 text-sm ">
                                <span className="text-sm-rent font-bold pr-4 md:hidden">Club:</span>
                                <span>{d.club}</span>
                            </td>
                            <td className="py-4 px-6 border-b border-gray-200 text-gray-900 text-sm ">
                                <span className="text-sm-rent font-bold pr-4 md:hidden">Cancha:</span>
                                <span>{d.field}</span>
                            </td>
                            <td className="py-4 px-6 border-b border-gray-200 text-gray-900 text-sm ">
                                <span className="text-sm-rent font-bold pr-4 md:hidden">pago:</span>
                                <span>{d.payment}</span>
                            </td>
                            <td className="py-4 px-6 border-b border-gray-200 text-gray-900 text-sm ">
                                <span className="text-sm-rent font-bold pr-4 md:hidden">Fecha Inicio:</span>
                                <span>{d.dateStart}</span>
                            </td>
                            <td className="py-4 px-6 border-b border-gray-200 text-gray-900 text-sm ">
                                <span className="text-sm-rent font-bold pr-4 md:hidden">Fecha Final:</span>
                                <span>{d.dateEnd}</span>
                            </td>
                            {type === 'integrar' ? (
                                <td className="py-4 px-6 border-b border-gray-200 text-gray-900 text-sm ">
                                    {' '}
                                    {d.status === 'Pagada' && (
                                        <span className="relative inline-block hover:cursor-pointer  px-3 py-1 font-semibold leading-tight rounded-full bg-blue-500  text-white">
                                            <Link to={`${d.sportUrl}/integrar/unirse/filter?gameId=${d.id}`}>
                                                Pagada
                                            </Link>
                                        </span>
                                    )}
                                    {d.status === 'Cancelado' && (
                                        <span className="relative inline-block px-3 py-1 font-semibold leading-tight rounded-full bg-red-500  text-black">
                                            {d.status}
                                        </span>
                                    )}
                                    {d.status === 'Pendiente' && !d.readyToPay ? (
                                        <span className="relative inline-block hover:cursor-pointer  px-3 py-1 font-semibold leading-tight rounded-full bg-yellow-500  text-black">
                                            <Link to={`${d.sportUrl}/integrar/unirse/filter?gameId=${d.id}`}>
                                                Espere ser notificado para realizar el pago
                                            </Link>
                                        </span>
                                    ) : (
                                        d.status === 'Pendiente' &&
                                        d.readyToPay && (
                                            <span className="relative inline-block hover:cursor-pointer  px-3 py-1 font-semibold leading-tight rounded-full bg-green-500  text-white">
                                                <Link to={`${d.sportUrl}/integrar/pago/filter?gameId=${d.id}`}>
                                                    Pagar
                                                </Link>
                                            </span>
                                        )
                                    )}
                                </td>
                            ) : type === 'rent' ? (
                                <td className="py-4 px-6 border-b border-gray-200 text-gray-900 text-sm ">
                                    <span className="relative inline-block hover:cursor-pointer  px-3 py-1 font-semibold leading-tight rounded-full bg-blue-500 text-white">
                                        {d.status}
                                    </span>
                                </td>
                            ) : (
                                <>
                                    <td className="py-4 px-6 border-b border-gray-200 text-gray-900 text-sm ">
                                        <span
                                            className={`relative inline-block  px-3 py-1 font-bold leading-tight text-sm-blue-primary rounded-full border-4 ${
                                                d.challengeType === 'DIRECT'
                                                    ? ' border-sm-rent '
                                                    : ' border-sm-integrate  '
                                            }`}
                                        >
                                            {d.challengeType === 'DIRECT' ? 'Dirigido' : 'Abierto'}
                                        </span>
                                    </td>
                                    <td className="py-4 px-6 border-b border-gray-200 text-gray-900 text-sm ">
                                        <div className="relative inline-block px-3 py-1 font-semibold leading-tight ">
                                            {d.challengerName}
                                            <hr /> Estatus:
                                            <hr />
                                            <span className="relative inline-block  px-3 py-1 font-semibold leading-tight rounded-full bg-purple-500  text-white">
                                                {d.challengerStatus}
                                            </span>
                                            <hr />
                                            Pago:
                                            <hr />
                                            <span className="relative inline-block  px-3 py-1 font-semibold leading-tight rounded-full bg-green-500  text-white">
                                                {d.challengerStatusPaid}
                                            </span>
                                            <hr />
                                        </div>
                                    </td>
                                    <td className="py-4 px-6 border-b border-gray-200 text-gray-900 text-sm ">
                                        <div className="relative inline-block px-3 py-1 font-semibold leading-tight ">
                                            {d.challengedName}
                                            <hr /> Estatus:
                                            <hr />
                                            <span className="relative inline-block   px-3 py-1 font-semibold leading-tight rounded-full bg-purple-500  text-white">
                                                {d.challengedStatus}
                                            </span>
                                            <hr />
                                            Pago:
                                            <hr />
                                            <span className="relative inline-block   px-3 py-1 font-semibold leading-tight rounded-full bg-green-500  text-white">
                                                {d.challengedStatusPaid}
                                            </span>
                                            <hr />
                                        </div>
                                    </td>
                                    <td className="py-4 px-6 border-b border-gray-200 text-gray-900 text-sm ">
                                        <span className="relative inline-block hover:cursor-pointer  px-3 py-1 font-semibold leading-tight rounded-full bg-blue-500  text-white">
                                            <Link to={`${d.sportUrl}/desafiar/equipo/filter?challengeId=${d.id}`}>
                                                Ver
                                            </Link>
                                        </span>
                                    </td>
                                </>
                            )}
                        </tr>
                    ))}
            </tbody>
        </table>
    );
}
